export default __webpack_public_path__ + "static/media/giphy.46a86830.gif";